import { useEffect } from 'react';

import { K8sProvider } from '@cast/shared-types';

import { useAgentScriptQuery } from 'hooks/queries/cluster';

import { ScriptSection } from '../../../../../../_components/new-onboarding';

import {
  RosaParametersForm,
  useRosaParametersForm,
} from '../../../../../../_components/RosaParametersForm';
import { colorOrToken, Stack, tokens } from '@cast/design-system';

type Props = {
  onHasScriptChanged: (hasScript: boolean) => void;
};

export const RosaScriptContent = ({ onHasScriptChanged }: Props) => {
  const { rosaFormProps, rosaQueryArg } = useRosaParametersForm();

  const { script, isLoading, error, refetch } = useAgentScriptQuery({
    provider: K8sProvider.ROSA,
    rosa: rosaQueryArg,
  });

  const hasScript = !!script;

  useEffect(() => {
    onHasScriptChanged(hasScript);
  }, [hasScript, onHasScriptChanged]);

  return (
    <Stack>
      <RosaParametersForm {...rosaFormProps} />
      <ScriptSection
        script={script}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
        sx={{
          backgroundColor: colorOrToken(
            'grey.100',
            tokens.theme.bg.structural.page
          ),
          mx: -24,
          px: 24,
          py: 20,
          mb: -20,
        }}
      />
    </Stack>
  );
};
